export default __webpack_public_path__ + "static/media/NumberOfTrialsWithREsultsPostedIcon.5aa36af8.svg";